import { courseQueryOptions } from '@features/groups/queries'
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/_teacher-portal/groups/my/department/$subjectId/$courseId')({
    component: Outlet,
    loader: async ({ params, context }) => {
        return context.queryClient.ensureQueryData(courseQueryOptions({ mode: 'id', id: params.courseId }))
    },
    staticData: {
        crumb: {
            dynamicLabel(match) {
                return `${match.loaderData?.programmeName} ${match.loaderData?.courseCode} (Course)`
            },
        }
    }
})
